module.exports = __webpack_public_path__ + "res/img_landing_what_we_do.2968257d9d4758fdc59269bb6b8402d1.webp";